// extracted by mini-css-extract-plugin
export var Anchor = "FeedbackSection-module--Anchor--RE2OI";
export var bg = "FeedbackSection-module--bg--5pEF6";
export var bxTextTruncateEnd = "FeedbackSection-module--bx--text-truncate--end--e5AZ2";
export var bxTextTruncateFront = "FeedbackSection-module--bx--text-truncate--front--bInqi";
export var darkMode = "FeedbackSection-module--dark-mode--svQ-x";
export var desc = "FeedbackSection-module--desc--GEMJE";
export var dotsElement = "FeedbackSection-module--dots-element--JDWUz";
export var flex = "FeedbackSection-module--flex--pMGdc";
export var imageContainer = "FeedbackSection-module--image-container--1R7xG";
export var introHeader = "FeedbackSection-module--intro-header--ZFy7+";
export var label = "FeedbackSection-module--label--HNOos";
export var left = "FeedbackSection-module--left--TGMSJ";
export var link = "FeedbackSection-module--link--4PwWw";
export var maxWidthFull = "FeedbackSection-module--max-width-full--wdzh8";
export var pageHeader = "FeedbackSection-module--page-header--NecG0";
export var text = "FeedbackSection-module--text--L+HIS";
export var withTabs = "FeedbackSection-module--with-tabs--7nWpL";